// extracted by mini-css-extract-plugin
export default {"content":"styles_content__xNJ4h","content_below":"styles_content_below__uLq7I","txt":"styles_txt__15dqH","fadein":"styles_fadein__qyJc1","visible":"styles_visible__BV1aB"};